module.exports = __webpack_public_path__ + "static/img/GettyImages---5953293121.0eb4675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/GettyImages---5953293121.jpg
// module id = JRuq
// module chunks = 0